export const GET_LEADS_AFFILIATE = 'GET_LEADS_AFFILIATE';
export const GET_LEADS_AFFILIATE_SUCCESS = 'GET_LEADS_AFFILIATE_SUCCESS';
export const GET_LEADS_AFFILIATE_FAILURE = 'GET_LEADS_AFFILIATE_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/constants/get_leads_affiliate.constants.js